import { PartialNullable } from "./Extensions";
import { IPromisePublic, PromiseHelper } from "./Helpers/PromiseHelper";
import { NAMESPACE } from "./_Namespace";
import { IRadObject, Property, RadObject, RadObjectPropertyValues } from "./RadObject";
import { WebApiClientService } from "./Server/WebApiClientService";
import { ServiceManager } from "./ServiceManager";

export type UtilityPropertyValues =
    RadObjectPropertyValues
    & {
    };

export type UtilityProperties = {
    [name in keyof UtilityPropertyValues]: Property<UtilityPropertyValues[name]>
};

export interface IUtility extends IRadObject, UtilityProperties
{
}

export class Utility extends RadObject<UtilityPropertyValues> implements IUtility
{
    public static override classNamespace = NAMESPACE + "Utility";
    public static override className = "Utility";

    // #region Static

    // #region Properties

    public static instance = new Utility();

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected guids: string[];
    protected loadingMoreGuids: boolean;
    protected newGuidRequests: IPromisePublic<string>[];

    // #endregion

    // #region Constructor

    private constructor(propertyValues?: PartialNullable<UtilityPropertyValues>)
    {
        super(propertyValues);

        this.guids = [];
        this.loadingMoreGuids = false;
        this.newGuidRequests = [];
    }

    // #endregion

    // #region Public Methods

    public newGuidAsync()
    {
        return this._newGuidAsync();
    }

    // #endregion

    // #region Protected Methods

    protected _loadMoreGuidsAsync()
    {
        this.loadingMoreGuids = true;

        return (
            ServiceManager.getRequired(WebApiClientService)
                .createApiMethodRequest("DataService", "CallDataService", { id: "3518088d-7425-4aca-b547-94759983b375", operation: "GuidList" })
                .executeAsync()
                .then((data: string[]) =>
                {
                    this.loadingMoreGuids = false;
                    data.forEach((item: string) => { this.guids.push(item); });
                })
        );
    }
    protected _newGuidAsync(waitingPromise?: IPromisePublic<string>): IPromisePublic<string>
    {
        const
            promise =
                waitingPromise
                    ? waitingPromise
                    : PromiseHelper.createPromisePublic<string>();

        if (this.loadingMoreGuids)
            this.newGuidRequests.push(promise);
        else
        {
            if (this.guids.length < 50)
            {
                this.newGuidRequests.push(promise);
                this._loadMoreGuidsAsync()
                    .then(() =>
                    {
                        const
                            requests = this.newGuidRequests.slice(0);

                        this.newGuidRequests = [];

                        requests.forEach(item => { this._newGuidAsync(item); });
                    });
            }
            else
                promise.resolve(this.guids.pop()!);
        }

        return promise;
    }

    // #endregion

    // #endregion
}

